import { DictionaryAutocomplete, useListSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useStates() {
  return useListSource<DictionaryAutocomplete>({
    url: `${EvidenceAPI.ISPOP_DOCUMENTS}/state/list`,
    method: 'GET',
  });
}
